import React, { useEffect, useRef, useState } from "react";
import CustomInput from "../component/CustomInput";
import { useNavigate } from "react-router-dom";
import ApiService from "../utils/ApiService";
import { ConfigProvider, Spin, Image, message } from "antd";
import { getOtpRemainingTime, retrieveOtpVerifyObj, storeOtpVerifyObj } from "../utils/Common";

function Otp() {
  const navigate = useNavigate();
  const otpVerifyObj = retrieveOtpVerifyObj();
  const [apiCalling, setApiCalling] = useState(false);
  const [error, setError] = useState("");
  const [payload, setPayload] = useState({
    purpose: "FORGOT_PASSWORD",
    countryCode: "880",
    phone: otpVerifyObj.phone,
    otp: "",
  });
  const [formPosition, setFormPosition] = useState({
    marginTop: "50px",
  });

  /** OTP Timer related*/

  const [otpStatus, setOtpStatus] = useState("active");
  const [displayTimer, setDisplayTimer] = useState("");
  let totalSeconds = useRef(118);
  let otpTimer;

  const startTimer = () => {
    totalSeconds.current = getOtpRemainingTime();
    otpTimer = setInterval(function () {
      if (totalSeconds.current < 0) {
        setOtpStatus("expired");
        clearInterval(otpTimer);
        setDisplayTimer("");
        return;
      }

      const min = `${Math.floor(totalSeconds.current / 60)}`.padStart(2, "0");
      let sec = `${totalSeconds.current % 60}`.padStart(2, "0");

      setDisplayTimer(`${min}:${sec}`);

      totalSeconds.current--;
    }, 1000);
  };

  useEffect(() => {
    startTimer();
    return () => {
      clearInterval(otpTimer);
    };
  }, []);
  
  /** end of OTP Timer related */

  useEffect(() => {
    calculateCenter();
  }, []);

  const calculateCenter = () => {
    const loginFormHeight = document.getElementById("login-form").offsetHeight;
    const mainFormHeight = document.getElementById("main-form").offsetHeight;
    let freeHeight = (mainFormHeight - loginFormHeight) / 3;
    setFormPosition({
      marginTop: `${freeHeight}px`,
    });
  };

  const goToLogin = () => {
    navigate("/");
  };

  const verifyOtp = () => {
    if (payload.otp.length < 4) {
      setError("Invalid OTP");
      return;
    }

    setApiCalling(true);

    ApiService.VERIFY_OTP(payload).then((res) => {
      setApiCalling(false);
      if (res.code === 200) {
        navigate("/set-new-password");
      } else {
        setError(res.message);
      }
    });
  };

  const sendOtp = async () => {
    try {
        setPayload({
            ...payload,
            otp: '',
          });

      setApiCalling(true);

      const res = await ApiService.FORGOT_PASSWORD(payload);

      setApiCalling(false);

      if (res.code !== 200) {
        message.error(res.message);
        return;
      }
      
      storeOtpVerifyObj(payload.phone);
      message.success("OTP sent successfully.");
      setOtpStatus("active");
      startTimer();
    } catch (error) {
      setApiCalling(false);
      message.error("Failed to send OTP. Please try again.");
    }
  };

  const goBack = () => {
    navigate("/forget-password");
  };

  const updateOtp = (val) => {
    if (val.length < 11 && /^\d*$/.test(val)) {
      setPayload({
        ...payload,
        otp: val,
      });
      setError('');
    }
  };

  return (
    <div
      id="main-form"
      style={{ height: "100vh" }}
      className="flex flex-col items-center p-[50px] bg-yellow"
    >
      <div
        id="login-form"
        style={formPosition}
        className="flex w-[360px] flex-col lg:w-[400px] bg-white justify-center border-[1px] border-gray-300 rounded-[5px] p-[20px]"
      >
        <div
          className="flex mb-[10px] items-center justify-center gap-x-[20px]"
          onClick={goToLogin}
        >
          <Image
            src={`/images/icons/TableTap_icon.svg`}
            preview={false}
            alt="tabletap"
            className="w-[96px] h-[96px]"
          />
          <div className="text-2xl font-bold text-red-600 font-ubold pb-[10px] content-center">
            <Image
              src={`/images/Scan_Order_Savor.png`}
              preview={false}
              alt="scan_order_savor"
              className="pt-[10px]"
            />
          </div>
        </div>
          <div className="text-red-700 ml-[20px] py-[8px] flex flex-col font-regular cursor-pointer">
            {error}
          </div>
          
        <CustomInput
          label="OTP"
          placeholder="Write otp here"
          onPressEnter={verifyOtp}
          value={payload.otp}
          setValue={updateOtp}
          required={true}
        />

        <div className="flex mr-5 mb-2 justify-end">
          {otpStatus === "expired" ? (
            <div className="cursor-pointer" onClick={sendOtp}>Resend OTP</div>
          ) : (
            <>
              Valid Till <div className="ml-2">{displayTimer}</div>
            </>
          )}
        </div>

        <div className="flex flex-row px-[16px] mt-[8px]">
          {apiCalling ? (
            <div className="w-[90px] text-center">
              <ConfigProvider
                theme={{
                  components: {
                    Spin: {
                      colorPrimary: "#EE3169",
                    },
                  },
                }}
              >
                <Spin
                  size="medium"
                  className="w-[66px]text-center items-center"
                />
              </ConfigProvider>
            </div>
          ) : (
            <button
              type="button"
              className="bg-yellow text-black px-[12px] py-[8px] rounded-[5px] font-ubold cursor-pointer"
              onClick={verifyOtp}
            >
              Verify
            </button>
          )}
          <div
            className="text-black px-[12px] py-[8px] font-ulight underline cursor-pointer"
            onClick={goBack}
          >
            Go Back
          </div>
        </div>
      </div>
    </div>
  );
}

export default Otp;
